import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { listDevices, updateDeviceHidden, type DeviceListItem } from '../api';

export default function Devices() {
  const [devices, setDevices] = useState<DeviceListItem[]>([]);
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState<Set<string>>(new Set());

  async function load() {
    try {
      setErr(null);
      const r = await listDevices();
      setDevices(r.devices);
    } catch (e) {
      setErr(String(e));
    }
  }
  useEffect(() => void load(), []);

  async function toggleHidden(name: string, next: boolean) {
    setBusy((s) => new Set(s).add(name));
    try {
      await updateDeviceHidden(name, next);
      setDevices((list) =>
        list.map((d) => (d.name === name ? { ...d, hidden: next } : d)),
      );
    } catch (e) {
      setErr(String(e));
    } finally {
      setBusy((s) => {
        const c = new Set(s);
        c.delete(name);
        return c;
      });
    }
  }

  return (
    <div>
      <h2>端末</h2>

      <div className="card">
        {err && <div className="error">{err}</div>}
        <table>
          <thead>
            <tr>
              <th>名前</th>
              <th>プリフィックス</th>
              <th>作成</th>
              <th>最終アクセス</th>
              <th>ダッシュボード除外</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {devices.map((d) => (
              <tr key={d.name}>
                <td>
                  <strong>{d.name}</strong>
                </td>
                <td>{d.prefix}</td>
                <td className="muted">{d.createdAt}</td>
                <td className="muted">{d.lastSeenAt}</td>
                <td>
                  <label style={{ display: 'inline-flex', gap: 6, alignItems: 'center' }}>
                    <input
                      type="checkbox"
                      checked={d.hidden === true}
                      disabled={busy.has(d.name)}
                      onChange={(e) => void toggleHidden(d.name, e.target.checked)}
                    />
                    <span className="muted">非表示</span>
                  </label>
                </td>
                <td>
                  <Link to={`/devices/${d.name}`}>
                    <button className="ghost small">詳細</button>
                  </Link>
                </td>
              </tr>
            ))}
            {devices.length === 0 && (
              <tr>
                <td colSpan={6} className="muted">
                  未登録
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
